import { render, staticRenderFns } from "./SesionSinRecinto.vue?vue&type=template&id=73c99388"
import script from "./SesionSinRecinto.vue?vue&type=script&lang=js"
export * from "./SesionSinRecinto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports